var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.22,
    height: 20.22,
    rx: 10.11,
    fill: "#D9DAE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28033 6.21967C6.98744 5.92678 6.51256 5.92678 6.21967 6.21967C5.92678 6.51256 5.92678 6.98744 6.21967 7.28033L9.04934 10.11L6.21967 12.9397C5.92678 13.2326 5.92678 13.7074 6.21967 14.0003C6.51256 14.2932 6.98744 14.2932 7.28033 14.0003L10.11 11.1707L12.9397 14.0003C13.2326 14.2932 13.7074 14.2932 14.0003 14.0003C14.2932 13.7074 14.2932 13.2326 14.0003 12.9397L11.1707 10.11L14.0003 7.28033C14.2932 6.98744 14.2932 6.51256 14.0003 6.21967C13.7074 5.92678 13.2326 5.92678 12.9397 6.21967L10.11 9.04934L7.28033 6.21967Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconGrey);
export default __webpack_public_path__ + "static/media/closeIconGrey.0db40e1ca7a86e53327f1ba6edaf65e0.svg";
export { ForwardRef as ReactComponent };